function arrayBetween(lowEnd, highEnd) {
  let arr = [];
  for (let i = lowEnd; i <= highEnd; i++) {
    arr.push(i);
  }
  return arr;
}
export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export const dayNames = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
];
export const yesNoOption = { rowType: 'dropdown', rowOptions: ['Yes', 'No'] };
export const yesNoNAOption = {
  rowType: 'dropdown',
  rowOptions: ['Yes', 'No', 'NA']
};
export const passFailOption = {
  rowType: 'dropdown',
  rowOptions: ['Pass', 'Fail']
};
export const leveedAreaOption = {
  rowType: 'dropdown',
  rowOptions: ['Flood Fill', 'Profile Projection', 'Flood Study', 'Other']
};
export const systemTypeOption = {
  rowType: 'dropdown',
  rowOptions: [
    'Levee',
    'Channel',
    'In-Ground Canal',
    'Elevated Canal',
    'Dam',
    'Coastal FRM',
    'FEMA Only',
    'Other'
  ]
};
export const alignmentAdjustmentOption = {
  rowType: 'dropdown',
  rowOptions: ['No', 'Yes - US', 'Yes - DS', 'Yes - US & DS']
};

export const textOption = { rowType: 'text' };
export const dateOption = { rowType: 'date' };
export const boolOption = { rowType: 'bool' };
export const linkOption = { rowType: 'link' };
export const emailOption = { rowType: 'email' };
export const demDates = arrayBetween(2000, 2024);

export const processingHoverText = {
  'Type of System':
    'Is the system a levee, channel, in-ground canal, elevated canal, or dam? Ref. FAQ #1.',
  'FIRM/NFHL Symbol': 'Is there a levee symbol on effective FIRM? Ref. FAQ #2.',
  'Alignment on Levee Crest':
    'Does the "updated_alignment" generally follow the top of embankments?',
  'Added New Features':
    'Did you add new features of different "Align_Type"(s) to the "updated_alignment"? Ref. FAQ #3.',
  'Alignment has Closure':
    'Does the "updated_alignment" contain a "closure" feature? Ref. FAQ #4.',
  'Alignment has Floodwall':
    'Does the "updated_alignment" contain a "floodwall" feature? Ref. FAQ #5.',
  'Alignment has Road':
    'Does the "updated_alignment" contain a "road" feature? Ref. FAQ #6.',
  'Alignment has Railroad':
    'Does the "updated_alignment" contain a "railroad" feature? Ref. FAQ #6',
  'Alignment has High Ground':
    'Does the "updated_alignment" contain a "high ground" feature? Ref. FAQ #7.',
  'Alignment has Bridge (CA style)':
    'Does the "updated_alignment" contain a "bridge" feature? Ref. FAQ #8.',
  'Alignment Lines Upstream to Downstream':
    'Are all lines in the "updated_alignment" going from upstream to downstream? Ref. FAQ #9.',
  'Alignment Lines in Same Direction':
    'Do all lines in the "updated_alignment" have the same direction? Ref. FAQ #9.',
  'Transects in Same Direction':
    'Do all transects have the same direction, either from land to river or river to land? Ref. FAQ #10.',
  'No Break between Two Connecting Alignment Lines':
    'Are all connecting lines in the "updated_alignment" snapped to each other at endpoints? Ref. FAQ #11.',
  'Transects have idx Values':
    'Do all transects have "idx" values that correspond with their associated alignment lines?',
  'Transects Cross':
    'Are there any two transects that cross each other? Ref. FAQ #12.',
  'Leveed Area at DEM Extent':
    'Does the "engineer_approved_leveed_area" touch the DEM boundary? Ref. FAQ #13.',
  'Leveed Area Special Case':
    'Is the "engineer_approved_leveed_area" a special case? Ref. FAQ #14.',
  'Best Leveed Area Method':
    'What is the main leveed area method used to create the "engineer_approved_leveed_area"? Ref. FAQ #15.',
  'Leveed Area Snapped to Alignment':
    'Is the boundary of the “engineer_approved_leveed_area” snapped to the “updated_alignment” with no gaps in between? Ref. FAQ #16.',
  'MaxEl Points on Levee Centerline':
    'Do the "transect_maxel_points" follow the levee embankment crest? Ref. FAQ #17.',
  'Alignment Updated':
    'Is the "updated_alignment" more updated/accurate than the "original_alignment"? Ref. FAQ #18.',
  'Leveed Area Updated':
    'Is the "engineer_approved_leveed_area" more updated/accurate than the original_leveed_area? Ref. FAQ #19.',
  'Report Run':
    'Did you run the report to create the CSV file(s) and Notebook HTML? Ref. FAQ #20.',
  Notes:
    'Provide justifications for your edits to the "updated_alignment" and "engineer_approved_leveed_area". Ref. FAQ #21.'
};

export const detailedQCHoverText = {
  'Processing Metadata':
    'Are all items under the "Processing Details" tab correct?',
  'Alignment Location':
    'Does the "update_alignment" correctly capture the embankment crest or other alignment features?',
  'Alignment Height':
    'Are all the spikes and dips of the alignment profile in the Notebook HTML legitimate?',
  'Alignment Type':
    'Does the "update_alignment" contain all necessary features with correct "Align_Type" attributes? FAQ #22.',
  'Entire Length of Protection Captured':
    'Does the "updated_alignment" represent a complete line of flood protection?',
  'Floodwalls/Closures':
    'Does the "update_alignment" contain all necessary floodwalls and closures?',
  Notes:
    'Do you have any comments for the Resonableness QCer or USACE? Notes for the analyst should be sent in an email.'
};

export const geospatialQCHoverText = {
  'Alignment Orientation':
    'Are all lines in the "updated_alignment" going from upstream to downstream? Ref. FAQ #9.',
  'No Break between Two Connecting Alignment Lines':
    'Are all connecting lines in the "updated_alignment" snapped to each other at endpoints? Ref. FAQ #11.',
  'Alignment Elevation Units':
    'Is the alignment`s elevation units in feet? Ref. FAQ #23.',
  'Polygon Valid':
    'Is the "engineer_approved_leveed_area" valid, e.g. without self-intersection/edges crossing?',
  'Polygon Vertices':
    'Does the "engineer_approved_leveed_area" have less than 100,000 vertices? Ref. FAQ #24.',
  'Majority of Interior Holes Removed':
    'Were small holes removed from the "engineer_approved_leveed_area"? Ref. FAQ #25.',
  Notes:
    'Do you have any comments for the Resonableness QCer or USACE? Notes for the analyst should be sent in an email.'
};

export const reasonablenessQCHoverText = {
  'Type of System':
    'Is the system a levee, channel, in-ground canal, elevated canal, or dam? Ref. FAQ #1.',
  'Leveed Area Method':
    'What is the main leveed area method used to create the "engineer_approved_leveed_area? Ref. FAQ #15.',
  'Elevation Source': 'What is the source DEM`s resolution?',
  'Elevation Date': 'What is the date of the source DEM?',
  'Geopackage Complete': 'Does the geopackage contain the expected layers?',
  'Transect with Toes Complete':
    'Do the transects have estimated toe locations?',
  'Alignment Acceptable':
    'Does the "updated_alignment" have the correct attributes and is spatially correct?',
  'Alignment Cartography':
    'Does the "updated_alignment" avoid unnecessary zig-zags?',
  'Leveed Area Acceptable':
    'Is the "engineer_approved_leveed_area" acceptable?',
  'DEM Acceptable': 'Is the DEM resolution/quality acceptable?',
  'Orthoimage Acceptable':
    'Are the referenced orthoimages of acceptable quality?',
  'USACE Recommendation':
    'Should USACE update the alignment/profile/leveed area, remove the system, or recategorize the system?',
  'Final Notes':
    'Final approved notes that will be used by USACE to populate the NLD.'
};

export const initialQCHoverText = {
  'Type of System':
    'Is the system a levee, channel, in-ground canal, elevated canal, or dam? Ref. FAQ #1.',
  'Alignment Adjustments':
    'Does the alignment line need to be adjusted in the upstream (US), downstream (DS), or US and DS directions?',
  Notes:
    'Do you have any comments on why you chose the type of system or the need for alignment adjustments?'
};
export const initialAnalystHoverText = {
  'FIRM/NFHL Symbol': 'Is there a levee symbol on effective FIRM? Ref. FAQ #2.',
  'Alignment Elevation Units':
    'Is the alignment`s elevation units in feet? Ref. FAQ #23.',
  'Alignment has Closure':
    'Does the "updated_alignment" contain a "closure" feature? Ref. FAQ #4.',
  'Alignment has Floodwall':
    'Does the "updated_alignment" contain a "floodwall" feature? Ref. FAQ #5.',
  'Alignment has Road':
    'Does the "updated_alignment" contain a "road" feature? Ref. FAQ #6.',
  'Alignment has Railroad':
    'Does the "updated_alignment" contain a "railroad" feature? Ref. FAQ #6',
  'Alignment has High Ground':
    'Does the "updated_alignment" contain a "high ground" feature? Ref. FAQ #7.',
  'Alignment has Bridge (CA style)':
    'Does the "updated_alignment" contain a "bridge" feature? Ref. FAQ #8.',
  'Best Leveed Area Method':
    'What is the main leveed area method used to create the "engineer_approved_leveed_area"? Ref. FAQ #15.',
  Notes:
    'Provide justifications for your edits to the "updated_alignment" and "engineer_approved_leveed_area". Ref. FAQ #21.',
  'Elevation Source': 'What is the source DEM`s resolution?',
  'Elevation Date': 'What is the date of the source DEM?'
};
export const finalQCHoverText = {
  'Type of System':
    'Is the system a levee, channel, in-ground canal, elevated canal, or dam? Ref. FAQ #1.',
  'Alignment Acceptable':
    'Does the "updated_alignment" have the correct attributes and is spatially correct?',
  'Leveed Area Acceptable':
    'Is the "engineer_approved_leveed_area" acceptable?',
  'USACE Recommendation':
    'Should USACE update the alignment/profile/leveed area, remove the system, or recategorize the system?',
  'Final Notes':
    'Final approved notes that will be used by USACE to populate the NLD.'
};
